// ANCHOR Base
import {
  Tag, TagOverrides,
} from 'baseui/tag';

// ANCHOR Styles
import { TAG } from './styles';

interface IProps {
  label: string;
  overrides?: TagOverrides;
  variant?: 'solid' | 'outlined';
  kind?: 'neutral' | 'negative' | 'primary';
}

export function CategoryTag({
  label,
  kind = 'neutral',
  variant = 'solid',
  overrides,
}: IProps) {
  return (
    <Tag
      overrides={overrides ?? TAG}
      kind={kind}
      variant={variant}
      closeable={false}
    >
      {label}
    </Tag>
  );
}
